import type { EntityBase } from '../types/Entities';

/**
 * checks if entity locale is allowed for user's current locale
 * entityLocale can have comma-separated values, each of them can be prefixed with `!` for negation
 */
export const isLocaleAllowed = (userLocal: string, entityLocale = ''): boolean => {
  if (!entityLocale) {
    return true;
  }

  const localeArray = entityLocale.toLowerCase().split(/\s*,\s*/);

  const shouldExcludeLocale = localeArray[0].startsWith('!');

  const isLocaleInList = localeArray.includes(shouldExcludeLocale ? `!${userLocal}` : userLocal);

  return shouldExcludeLocale ? !isLocaleInList : isLocaleInList;
};

export const getAllowedEntitiesForLocale = <Entity extends EntityBase>(locale: string, entities: Entity[]) =>
  entities.filter(({ locale: itemLocale }) => isLocaleAllowed(locale, itemLocale));
